import { render, staticRenderFns } from "./LPUserCard.vue?vue&type=template&id=559b9738&scoped=true"
import script from "./LPUserCard.vue?vue&type=script&lang=ts"
export * from "./LPUserCard.vue?vue&type=script&lang=ts"
import style0 from "./LPUserCard.vue?vue&type=style&index=0&id=559b9738&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "559b9738",
  null
  
)

export default component.exports